// authSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authenticationStoreType } from '../utils/types';

const initialState: authenticationStoreType = {
    isAuthenticated: false,
    isConcierge: false,
    clientID: null,
    deviceDetails: null,
    loginUserInfo: {},
    insurance: null,
    conciergeNumber: null,
    conciergeID: null,
    clientName: null,
    restrictions: [],
    userType: null
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setDeviceDetails: (state, action: PayloadAction<string>) => {
            const browserVersion: string = navigator.userAgent;
            const timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const language: string = navigator.language;
            const plugins: number = Array.from(navigator.plugins).length;
            const screenResolution: string = `${screen.width}x${screen.height}`;
            const device_fingerprint = action.payload;

            state.deviceDetails = {
                browserVersion,
                timeZone,
                language,
                plugins,
                screenResolution,
                device_fingerprint
            };
        },
        setAuthStatus: (state, action: PayloadAction<{ isAuthenticated: boolean; isConcierge: boolean }>) => {
            state.isAuthenticated = action.payload.isAuthenticated;
            state.isConcierge = action.payload.isConcierge;
        },
        setAuthenticationStatus: (state, action: PayloadAction<{ isAuthenticated: boolean}>) => {
            state.isAuthenticated = action.payload.isAuthenticated;
        },
        setLoginUserInfo: (
            state,
            action: PayloadAction<{ email?: string; mobile?: string }>
        ) => {
            state.loginUserInfo = action.payload;
        },
        setSessionInfo: (
            state,
            action: PayloadAction<{ email?: string; mobile?: string;
                insurance?: string; clientID?: string; conciergeNumber?: string
                conciergeID?: string, clientName ?: string, restrictions?: string[],
                userType?: string}>
        ) => {
            state.loginUserInfo = {
                email: action.payload.email,
                mobile: action.payload.mobile,
            };
            state.insurance = action.payload.insurance || null;
            state.clientID = action.payload.clientID || null;
            state.conciergeNumber = action.payload.conciergeNumber || null;
            state.conciergeID = action.payload.conciergeID || null;
            state.clientName = action.payload.clientName || null;
            state.restrictions = action.payload.restrictions || [];
            state.userType = action.payload.userType || null;
            
        }

    }
});

export const authAction = authSlice.actions;

export default authSlice.reducer;
